/**
 * Adds or removes item in array
 *
 * @example
 * ```
 * arrayToggle(3, [1, 2, 4, 5]) => [1, 2, 4, 5, 3];
 * arrayToggle(3, [1, 2, 3, 4, 5]) => [1, 2, 4, 5];
 * ```
 *
 * @param toggleItem - item to toggle
 * @param array - array of items
 */
export function arrayToggle<T>(toggleItem: T, array: T[]): T[] {
  const newArr: T[] = [];
  let removed = false;

  // add items to new array
  array.forEach((item, index) => {
    // exclude toggleItem
    if (item === toggleItem) {
      removed = true;
      return;
    }

    newArr.push(item);
  });

  // if toggleItem isn't excluded
  if (!removed) {
    // add toggleItem to array
    newArr.push(toggleItem);
  }

  return newArr;
}
